var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-bar',{attrs:{"items":[
      { title: 'Usuarios', to: "/users" },
      { title: _vm.title_page } ]}}),_c('div',{staticClass:"box"},[_c('Form',{on:{"oncancel":function () { return _vm.$router.back(); },"onsuccess":function () { return _vm.$router.back(); }},model:{value:(_vm.row),callback:function ($$v) {_vm.row=$$v},expression:"row"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }